import textWrapping from "./textwrapping";
export default function(ctx, start, inputController) {
    let consoleRow = 0;

    function resize() {
        ctx.width = ctx.canvas.width = 1920; //window.innerWidth;
        ctx.height = ctx.canvas.height = 1080; //window.innerHeight;
    }

    function drawBackground() {
        let gradient = ctx.createLinearGradient(0, ctx.height, 0, 0);
        gradient.addColorStop(0, "#000000");
        gradient.addColorStop(1, "#1a2a15");
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, ctx.width, ctx.height);
    }
    
    function drawTerminal() {
        ctx.strokeStyle = "#00FF00";
        ctx.fillStyle = "rgba(0, 0, 0, .4)";
        ctx.lineWidth = 5;
        ctx.roundRect(ctx.width * .02, ctx.width * .02, ctx.width * .8, ctx.height * .75, ctx.width * .007, true, true);
    }
    
    function drawOutputHistory(history) {
        consoleRow = 0;

        ctx.font = "30px Special Elite";
        ctx.fillStyle = "#00FF00";   

        let wrappedHistory = history.map(value => {
            let result = [];
            let textLines = value.split('\n');
            textLines.forEach(textLine => {
                let wrappedLines = textWrapping.lines(textLine, ctx.width * .76, ctx);
                wrappedLines.forEach(wrappedLine => { 
                    result.push(wrappedLine);
                });
            });
            return result;
        });
        wrappedHistory = wrappedHistory.reduce((acc, val) => acc.concat(val), []);

        const pageCount = Math.min(wrappedHistory.length, rowLimit());
        for(var index = 0; index<pageCount; index++){
            let rowIndex = pageCount-index,
            text = wrappedHistory[wrappedHistory.length-rowIndex];

            ctx.fillText(text, ctx.width * .04, ctx.width * .03 + 35 + consoleYPos());
            consoleRow++;
        }

    }

    function drawPrompt(promptLeft, terminalTop, disableCursor) {
        const
            yTop = terminalTop + consoleYPos(),
            lineText = "> " + inputController.currentInput();
        const lines = textWrapping.lines(lineText, ctx.width * .74, ctx);

        for(var i = 0; i<lines.length; i++) {
            ctx.fillText(lines[i], promptLeft, yTop + (i * 35));
        }

        // Cursor
        const diff = (Date.now() - start),
            cursorIsOn = Math.floor(diff / 500) % 2 == 0;
        if (cursorIsOn && !disableCursor) {
            let index = 2 + inputController.cursorColumn(), 
                metrics = ctx.measureText(lineText.substring(0, index)),
                cursorWidth = index === lineText.length ? 15 : 
                    ctx.measureText(lineText[index]).width,
                    widthToCursor = metrics.width;
            ctx.fillStyle = "rgba(0, 255, 0, .5)";
            ctx.fillRect(promptLeft + widthToCursor, yTop - 30, cursorWidth, 35);
        }
    }

    function consoleYPos() {
        return consoleRow * 35;
    }

    function rowLimit() {
        return Math.round((ctx.height * 0.75) / 35) - 3;
    }

    // window.addEventListener("resize", resize);
    resize();

    return {
        drawBackground() {
            drawBackground();
        },
        drawGui(history, disableCursor) {
            // drawBackground();
            drawTerminal();
            drawOutputHistory(history);
            // TODO: Disable prompt or cursor?
            if (!disableCursor) {
                drawPrompt(ctx.width * .04, ctx.width * .03 + 35, disableCursor);
            }
        }
    }

}